import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');

document.addEventListener('DOMContentLoaded', function() {
    window.videoInit = function() {    
        const el = document.getElementsByClassName('js-player');    
        for (let i = 0; i < el.length; i++) {
            const player = new Plyr(el[i]);
        }
    };

}, false)
